import { Context, type Effect, Layer, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { FrontendThemeFailure, ThemeSnapshot } from "./theme-model.ts";

export interface ThemeStyleLease {
  readonly scopeId: unknown;
  readonly write: (css: string) => Effect.Effect<void, FrontendThemeFailure>;
}
export class ThemeStyleIo extends Context.Service<ThemeStyleIo, {
  readonly connect: Effect.Effect<ThemeStyleLease, FrontendThemeFailure, Scope.Scope>;
}>()("workerstation/frontend/ThemeStyleIo") {}
export const ThemeStyleIoTest = (io: typeof ThemeStyleIo.Service) => Layer.succeed(ThemeStyleIo, io);
export interface ThemeController {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<ThemeSnapshot>>;
  readonly read: Effect.Effect<ThemeSnapshot>;
  readonly initialize: (id: string) => Effect.Effect<void>;
  readonly select: (id: string) => Effect.Effect<void>;
}
export class FrontendThemes extends Context.Service<FrontendThemes, {
  readonly open: Effect.Effect<ThemeController>;
}>()("workerstation/frontend/FrontendThemes") {}
